import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserRolePermissions, SilentThunkError } from '@socialive/common';
import { selectCurrentAccountId } from '../../accountInfo/selectors';
import fetchTrayAvailableWorkflows from './fetchTrayAvailableWorkflows';
import fetchTraySolutionInstances from './fetchTraySolutionInstances';
import fetchTrayUserId from './fetchTrayUserId';
import fetchTrayUserToken from './fetchTrayUserToken';

export default createAsyncThunk('connectionManager/fetchTray', async (_, { dispatch, getState }) => {
  const accountId = selectCurrentAccountId(getState());
  const { canPublishVideo } = selectUserRolePermissions(getState());

  if (!canPublishVideo) {
    throw new SilentThunkError('No Permissions to use tray');
  }

  await dispatch(fetchTrayUserId({ accountId })).unwrap();

  const [{ error: trayUserTokenError }, { error: trayWorkflowsError }] = await Promise.all([
    dispatch(fetchTrayUserToken({ accountId })),
    dispatch(fetchTrayAvailableWorkflows({ accountId })),
  ]);

  if (trayUserTokenError || trayWorkflowsError) {
    throw new SilentThunkError(trayUserTokenError?.message ?? trayWorkflowsError?.message);
  }

  await dispatch(fetchTraySolutionInstances({ accountId }));

  return { timestamp: Date.now(), accountId };
});
